import { render, staticRenderFns } from "./NumberFormatPlayground.vue?vue&type=template&id=628616da&"
import script from "./NumberFormatPlayground.vue?vue&type=script&lang=js&"
export * from "./NumberFormatPlayground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports